/** 403 = gate de rol (módulo ausente). No es 401: la sesión sigue viva. */

export function isForbiddenError(error: unknown): boolean {
  if (error == null || typeof error !== "object") return false;
  return (error as { status?: unknown }).status === 403;
}

/** 5xx: falla de servidor. No disfrazar como lista vacía. */
export function isServerError(error: unknown): boolean {
  if (error == null || typeof error !== "object") return false;
  const status = (error as { status?: unknown }).status;
  return typeof status === "number" && status >= 500;
}

/** POST /auth/logout/ — 401 = ya no hay sesión; no reintentar ni tratarlo como expire. */
export function isLogoutEndpoint(endpoint: string): boolean {
  return endpoint.startsWith("/auth/logout");
}

/** 401 que no debe disparar interceptor de sesión (redirect / segundo logout). */
export function shouldSkipSessionExpireRedirect(endpoint: string): boolean {
  return (
    endpoint.startsWith("/setup/") ||
    endpoint.startsWith("/auth/login") ||
    endpoint.startsWith("/auth/mfa") ||
    isLogoutEndpoint(endpoint)
  );
}

/** Para catálogos/polls: un 403 esperado se traga; el resto se relanza. */
export function emptyOnForbidden<T>(fallback: T) {
  return (error: unknown): T => {
    if (isForbiddenError(error)) return fallback;
    throw error;
  };
}
